import { accountingType } from '@/features/master-table/models';
import { DateRangeSchema } from '@/utils';
import {
  implementationMethodEnum,
  projectCategoryEnum,
  sheetTypeEnum,
} from '@/utils/enum';
import { z } from 'zod';

/**タグやfieldの共通項目を型安全に使用するために定義*/
export const AnalysisAndProjectsSharedSearchSchema = z.object({
  sheetType: sheetTypeEnum,
  q: z.string().nullable(),
  isSearchTargetProjectName: z.boolean().nullable(),
  corporateNumber: z.string().nullable(),
  categories: projectCategoryEnum.array().nullable(),
  implementationMethods: implementationMethodEnum.array().nullable(),
  accountingType: accountingType.nullable(),
  accountingTypeIds: z.string().uuid().array().nullable(),
  projectNumbers: z.string().nullable(),
  period: DateRangeSchema.nullable(),
  // cascader項目
  nestedOrganizationIds: z.string().uuid().array().array().nullable(),
  nestedPolicyIds: z.string().uuid().array().array().nullable(),
  nestedOtherResponsibleOrganizationIds: z
    .string()
    .uuid()
    .array()
    .array()
    .nullable(),
  nestedExpenditureBudgetPurposeIds: z
    .string()
    .uuid()
    .array()
    .array()
    .nullable(),
});

export type SharedSearchFormType = z.infer<
  typeof AnalysisAndProjectsSharedSearchSchema
>;
